import { GlobalClassInstance } from '@commoncore/constants/GlobalClass';
import { FileOperationsImplementation } from '@commoncore/implementation/FileOperationsImplementation';
import { TeamFoldersImplementation } from '@commoncore/implementation/TeamFoldersImplementation';
import { GlobalService } from '@commoncore/services/global.service';
import { AppEvents } from '@commoncore/utils/app-events';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';
import { Controller } from './Controller';

export class TeamFoldersController extends Controller{
    public universalService:any;
    public router:any;
    public http:any;
    public static singleInstance:any = null;
    public fileOpsController:any;
    tfImpl: any;
    localStorageSvc:any;
    listService: any;
    fileOperationsImplementation: any;
    lazyLoadImgService:any;
    sessionStorageService:any

    public constructor(public globalService:GlobalService) {
      super(globalService);
      this.tfImpl = TeamFoldersImplementation.getInstance(this.globalService);
      this.fileOperationsImplementation = FileOperationsImplementation.getInstance(globalService);
      this.sessionStorageService = globalService.getSessionStorageSvcRef();
    }
    
    public static getInstance(globalService):TeamFoldersController{
      if(this.singleInstance == null){
        this.singleInstance = new TeamFoldersController(globalService);
        return this.singleInstance;
      }else{
        return this.singleInstance;
      }
	  }


    public setEnvObjects(globalService){
        this.universalService = globalService.getUniversalServiceRef();
        this.router = globalService.getRouterRef();
        this.http = globalService.getHttpClientRef();
        this.localStorageSvc = globalService.getLocalStorageSvcRef();
        this.listService = globalService.getListServiceRef();
        this.lazyLoadImgService = globalService.getLazyLoadImgServiceRef();
        if(this.universalService.virtualGridEnabled){
          this.lazyLoadImgService = globalService.getVirtualLazyLoadImgServiceRef();
        }
    }

    async getAllTeamFoldersUser(limit){
      limit = limit == ENV_CONFIG["constants"]["PAGE_LIMIT"] ? limit * ENV_CONFIG["constants"]["PAGINATION_BUFFER"] : limit
      let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["tmfldURL"] + ENV_CONFIG.commonUrls["userTeamFolders"] + '?limit=' + limit + "&sort=%2DlastUpdatedDate";
      this.tfImpl.setHandler(this.globalService);
      this.universalService.showLoader = true;
      try {
        var result = await this.tfImpl.getAllTeamFoldersUser(url);
        return result;
      } catch (error) {
        console.log(error);
        return null;
      }
    }

    clearView(){
      this.universalService.sortByDateArray = [];
      this.universalService.sortByNameArray = [];
      this.universalService.foldersArray = [];
    }

    async getCurrentTeamFolderContent(objectKey,onSortChange=false){
      let limit = ENV_CONFIG["constants"]["PAGE_LIMIT"];
      let objKey = objectKey;
      let currentTF = this.universalService.currentTeamFolder;
      let tfKey = currentTF["tfKey"];
      this.tfImpl.setHandler(this.globalService);
      var result = null;
      this.universalService.showLoader = true;
      try {
        this.universalService.shareViewTypeSetting();
        let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["tmfldURL"] + ENV_CONFIG.commonUrls["nonadminTeamFolderMetadataOptimised"];
        if(this.universalService.listView && !this.universalService.isMobileDevice) {
          url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["tmfldURL"] + ENV_CONFIG.commonUrls["nonadminTeamFolderMetadata"];
        }
        url += "?folderKey=" + objectKey + "&tfKey="+tfKey+"&limit="+limit;
        if((this.universalService.listView && !this.universalService.isMobileDevice)){
          url = url.replace(limit.toString(),limit * ENV_CONFIG["constants"]["PAGINATION_BUFFER"] + "");
          result = await this.tfImpl.getCurrentTeamFolderContent(url,"filesAndFolders"); //for list fetch wil be with old impl
          //result = await this.fetchFolders(url); //With new api first fetch folders and then files
        }else if (this.universalService.virtualGridEnabled){
          this.clearView();
          url = url.replace(limit.toString(),limit * ENV_CONFIG["constants"]["PAGINATION_BUFFER"] + "");
          result = await this.fetchFolders(url);
        } else {
          this.universalService.sortByNameArray = [];
          this.universalService.sortByDateArray = [];
          this.universalService.foldersArray = [];
          this.universalService.mobileSelectedObj = [];
          result = await this.fetchFolders(url); //if(!onSortChange)  // as discussed with Prashant, commenting it.
          result = await this.fetchFiles(url)
        }
        return result;
      } catch (error) {
        console.log(error);
        return null;
      }
    }

    async fetchFolders(url) {
      url = url + "&type=w";
      if(!this.universalService.virtualGridEnabled && (!this.universalService.listView || this.universalService.isMobileDevice)){
        url = url.replace(ENV_CONFIG["constants"]["PAGE_LIMIT"],"1000");
      }
      var result = null;
      this.universalService.showLoader = true;
      try {
        if(this.universalService.listView && !this.universalService.isMobileDevice) {
          result = await this.tfImpl.getCurrentTeamFolderContent(url);
        } else {
          result = await this.tfImpl.getCurrentTeamFolderContent(url,"foldersOnly");
        }
      } catch (error) {
        console.log(error);
      }
    }

    async fetchFiles(url) {
      url = url + "&type=f";
      url = url.replace(ENV_CONFIG["constants"]["PAGE_LIMIT"].toString(),ENV_CONFIG["constants"]["PAGE_LIMIT"] * ENV_CONFIG["constants"]["PAGINATION_BUFFER"] + "");
      var result = null;
      this.universalService.showLoader = true;
      try {
        result = await this.tfImpl.getCurrentTeamFolderContent(url,"filesOnly");
      } catch (error) {
        console.log(error);
      }
    }

    openFolder(folder) {
      var collapsedHeight = $('#m-collapsed-modal .modal-content').height();
      collapsedHeight = collapsedHeight?collapsedHeight:0
      this.fileOperationsImplementation.setHandler(this.globalService);
      const result = this.fileOperationsImplementation.openFolder(folder); 
    }

    decideScrollCall(){
      if(this.listService.listOptions.api.getDisplayedRowCount() == 0) return
      var url = "";
      url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["tmfldURL"] + this.tfImpl.tfsNextLink;
      this.tfImpl.setHandler(this.globalService);
      try {
        this.tfImpl.createUrlForNextLinkOnDesktop(url);
      }
      catch (exc) {
        console.log("exception in scroll down",exc);
      }
    }

    openPublicSort(sortType,reverseOrder){
      this.universalService.disableModalBackdrop();
      let sortTypeName = this.universalService.togglePublicSort(sortType,reverseOrder);
      if(sortTypeName!=""){
        this.sessionStorageService.setSharePublicSortPropName(sortTypeName);
      }
      //this.allFilesImplementation.allFilespreviousLink = "";
      this.tfImpl.tfsNextLink = "";
      this.tfImpl.tfsPreviousLink = "";
      let currTmfldObjectKey = this.sessionStorageService.getNestedTeamFolderkey();
      this.getCurrentTeamFolderContent(currTmfldObjectKey,false);
      this.universalService.isMobileTopMoreOptionMenu = false;
    }

    onScrollDown(docheignt, toppos,containerName){
      let self = this;
      if(!this.universalService.virtualGridEnabled){
        self.lazyLoadImgService.isScrollingStopped();
      }
      var url = "";
      url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["tmfldURL"] + self.tfImpl.tfsNextLink;
      try {
        self.tfImpl.createUrlForNextLink(docheignt,toppos,url,containerName);
      }
      catch (exc) {
        console.log("exception in mobile scroll down",exc);
      }
    }

    async updateUIAfterPerformingAction(list,executedTask,leftTeamFolder=null){
      var array = [];
      if(this.universalService.nameSort){
        array = this.universalService.sortByNameArray
      }else{
        array = this.universalService.sortByDateArray
      }
      if(executedTask == 'TRASH' || executedTask == "MOVE"){
        this.fileOperationsImplementation.setHandler(this.globalService);
        if( this.universalService.currentTab == 'teamfolders' || executedTask == 'TRASH'){
          var result = await this.fileOperationsImplementation.updateSummaryCountsAndUI(array,list,executedTask);
          array = result
        }
        if(this.universalService.virtualGridEnabled){
          AppEvents.virtualDOMObservable.next({"updateVDOM":true,"removeObjects":true,objectsList:list})
        }
      }else if(executedTask == 'RENAME' || executedTask == 'SETFAV' || executedTask == 'UNSETFAV' || executedTask == "SHAREPERMISSION"){
        this.fileOperationsImplementation.setHandler(this.globalService);
        var result = await this.fileOperationsImplementation.updateOnlyTheUI(array, list,executedTask)
        array = result;
        if(this.universalService.virtualGridEnabled){
          let updatedList = this.fileOperationsImplementation.returnTheListOfUpdatedObjectsForVirtualGrid(list,array);
          AppEvents.virtualDOMObservable.next({"updateVDOM":true,"updateObjects":true,objectsList:updatedList})
        }
      }else if(executedTask == "LEAVETEAMFOLDER"){
        this.tfImpl.setHandler(this.globalService);
        if(this.universalService.listView && !this.universalService.isMobileDevice){
          var result = await this.tfImpl.updateUIListView(executedTask,leftTeamFolder)
          if(this.listService.listOptions.api.getDisplayedRowCount() == 0){
            this.fetchNextPageData(executedTask);
          }
        }else{
          var result = await this.tfImpl.updateTheUIMobileView(executedTask,leftTeamFolder);
          if(result.length == 0){
            this.fetchNextPageData(executedTask)
           }
        }
      }else{
        console.log("task invalid",executedTask)
      }
      if(array.length == 0){
        return "empty"
      }else{
        return ""
      }
    }


    async fetchNextPageData(executedTask){
      if(this.tfImpl.tfsNextLink != ""){
        var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["tmfldURL"] + this.tfImpl.tfsNextLink;
        try{
          this.listService.disableSelectionModeInListView = true;
          var result = await this.tfImpl.getNextPageData(url);
          if(result["objects"].length == 0){
            this.universalService.showLoader = true;
            if(executedTask == "LEAVETEAMFOLDER"){
              this.getAllTeamFoldersUser(ENV_CONFIG["constants"]["PAGE_LIMIT"]);
            }
          }
        }
        catch(exc){
          console.log("exception in scroll down",exc)
        }
      }else {
        if(executedTask == "LEAVETEAMFOLDER"){
          this.getAllTeamFoldersUser(ENV_CONFIG["constants"]["PAGE_LIMIT"]);
        }
      }
    }


    selectAll(event){
      this.tfImpl.selectAll(event)
    }


}